import httpServer from "../axios";
import {baseUrlt} from "..";

export default {
  updateTarinRoom(params){
    return httpServer('post',`${baseUrlt}api/training/room/update`, params);
  },
  updateMethod(params){
    return httpServer('post',`${baseUrlt}api/class/train/log/update/${params.id}`, params);
  },
  updateRepair(params){
    return httpServer('post',`${baseUrlt}api/devicerepair/setRepairStatus`, params);
  },
  updateKeep(params){
    return httpServer('post',`${baseUrlt}api/devicekeep/setKeepStatus`, params);
  },
  updateJournalOfClass(params){
    return httpServer('post',`${baseUrlt}api/class/train/class_log/update/${params.id}`, params);
  },
  updateJournalOfTearcher(params){
    return httpServer('get',`${baseUrlt}api/class/charge/teacher/update/${params.id}`, params);
  },
  confirmEqSK(params){
    return httpServer('get',`${baseUrlt}api/class/charge/class_teacher/confirm/${params.id}`, params);
  },
  confirmEqSX(params){
    return httpServer('get',`${baseUrlt}api/class/charge/train_teacher/confirm/${params.id}`, params);
  },
  updateApplyStatus(params){
    return httpServer('get',`${baseUrlt}api/room/order/train_teacher/examine/${params.id}/${params.status}`);
  },
  updateClassPlan(params){
    // return httpServer('post',`${baseUrlt}api/class/plan/update/${params.id}`, params);
    return httpServer('post',`${baseUrlt}api/xmhy/class/plan/update/${params.id}`, params);
  },
  updateClassPlanV2(params){
    return httpServer('post',`${baseUrlt}api/training_plan/v2/edit/${params.id}`, params);
  },
  updateCourseApplyStatus(params){
    return httpServer('post',`${baseUrlt}api/class/plan/audit/${params.id}`,params);
  },
  updateUser(params){
    return httpServer('post',`${baseUrlt}api/user/edit`,params);
  },
  bindOrgan(params){
    return httpServer('post',`${baseUrlt}api/school/user_structure/update`,params);
  },
  updateQItem(params){
    return httpServer('post',`${baseUrlt}api/grade/index/update/${params.id}`,params);
  },
  applyPlanStatus(params){
    return httpServer('post',`${baseUrlt}api/training_plan/admin/oper`,params);
  },
  studentApplyPlane(params){
    return httpServer('post',`${baseUrlt}api/student/training_plan/apply`,params);
  },
  operStudentApply(params){
    return httpServer('post',`${baseUrlt}api/training_plan/teacher/operStudentApply`,params);
  },
  studentScoreAdd(params){
    return httpServer('post',`${baseUrlt}api/training_plan/teacher/studentScoreAdd`,params);
  },
  consumedAdd(params){
    return httpServer('post',`${baseUrlt}api/training_plan/consumeUpdate`,params);
  },
  updateItemConfig(params){
    return httpServer('post',`${baseUrlt}api/training_plan/planScoreItemEdit`,params);
  },
  updateTrainBase(params){
    return httpServer('post',`${baseUrlt}api/training_base/edit`,params);
  },
  updateRead(params){
    return httpServer('post',`${baseUrlt}api/message/read`,params);
  },
  updateSchool(params){
    return httpServer('post',`${baseUrlt}api/school/admin/edit`,params);
  },
  updateSchoolStatus(params){
    return httpServer('post',`${baseUrlt}api/school/admin/setDisabled`,params);
  },
  updateTrainRommOpen(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/open/edit`,params);
  },
  updateTrainRommCup(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/computer_use/edit`,params);
  },
  updateTrainRommFunds(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_room/funds/edit`,params);
  },
  updateTrainBaseOut(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/edit`,params);
  },
  updateCollaborate(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/collaborate`,params);
  },
  updateTrainBaseOutItem(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/baseScoreItemEdit`,params);
  },
  baseScoreAdd(params){
    return httpServer('post',`${baseUrlt}api/xmhy/training_base_out/baseScoreAdd`,params);
  },
  operDevicePurchase(params){
    return httpServer('post',`${baseUrlt}api/device/purchase2/oper`,params);
  },
  operPurchase(params){
    return httpServer('post',`${baseUrlt}api/consume/purchase/oper`,params);
  },
  setDefaultOrgan(params){
    return httpServer('post',`${baseUrlt}api/school/user_structure/setDefault`,params);
  },
  changeDeviceNumber(params){
    return httpServer('post',`${baseUrlt}api/device/adjustRemainder`,params);
  },
  changeConsumeNumber(params){
    return httpServer('post',`${baseUrlt}api/consume/adjustRemainder`,params);
  },
};